module.exports = __webpack_public_path__ + "static/media/resume.835d492c.png";